import PropTypes from 'prop-types';

const displayName = 'TnCPage';
const propTypes = {
  location: PropTypes.object,
  setLoading: PropTypes.func,
};
const defaultProps = {
  location: {
    state: {
      contentUrl: '',
    },
  },
};

export default { displayName, propTypes, defaultProps };
